<template>
    <div class="agent-testimonials mx-auto">
        <b-container class="bg-white">
            <b-card class="bg-white">
                <b-breadcrumb class="bg-white" :items="this.breadcrumb_items"></b-breadcrumb>
                <b-row>
                    <b-col md="9" class="mt-2">
                        <h4><b>What people are saying about {{this.user.first_name}}</b></h4>
                    </b-col>
                    <b-col md="3" class="mt-2">
                        <a :href="edit_route" v-if="canEdit" class="btn btn-outline-secondary">
                            Manage Testimonials
                        </a>
                        <b-button v-if="!canEdit" variant="outline-secondary" @click="writeTestimonial">
                            Write a Testimonial
                        </b-button>
                    </b-col>
                </b-row>
                <hr>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card border-0 shadow-none">
                            <!-- /.card-header -->
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table m-0">
                                        <tbody>
                                        <tr v-for="testimonial in this.testimonials">
                                            <b-card>
                                                <b-card-text class="quote">
                                            <span v-if="!checkifActivated(testimonial.id)"
                                                  v-html="testimonial.text.slice(0, 500)"></span>
                                                    <a class="btn" v-if="!checkifActivated(testimonial.id)"
                                                       @click="activateReadMore(testimonial.id)">
                                                        <br>Read more...</a>
                                                    <span v-if="checkifActivated(testimonial.id)"
                                                          v-html="testimonial.text + ' -<b>' + testimonial.user_nickname + '</b>'"></span>
                                                </b-card-text>
                                            </b-card>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>

        </b-container>
        <b-modal id="testimonialModal" ref="testimonialModal" title="Write a Testimonial" size="lg">
            <write-testimonial ref="writeTestimonial" :agent="agent"></write-testimonial>
            <div slot="modal-footer" class="w-100"></div>
        </b-modal>
        <!-- Loading element -->
        <div id="loading" class="loading" v-if="isLoading">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>


<script>

export default {
    name: 'agent-testimonials',
    props: {
        slug: {
            type: String,
            default: ""
        },
    },
    beforeMount() {
        this.getAgent();
    },
    data() {
        return {
            canEdit: true,
            agent: null,
            user: null,
            activatedArray: [],
            readMoreActivated: false,
            testimonials: [],
            breadcrumb_items: [],
            edit_route: "/admin/agents/testimonials/" + this.$route.params.slug
        }
    },
    methods: {
        setEditable(){
            let _self = this;

            this.editable = !_self.editable;
        },
        getAgent() {
            let _self = this;
            let route = '/api/agents/testimonials/' + this.$route.params.slug
            axios.get(route)
                .then(response => {
                    _self.agent = response.data.agent;
                    _self.user = response.data.agent.user;
                    _self.testimonials = response.data.testimonials;

                    _self.breadcrumb_items = [
                        {
                            'text': 'Home',
                            'href': "/"
                        },
                        {
                            'text': _self.user.first_name + "'s Profile",
                            'href': "/" + this.agent.slug
                        },
                        {
                            'text': _self.user.first_name + "'s Testimonials",
                            'href': "#"
                        }
                    ];
                });
        },
        getMe(){
            let _self = this;
            let promise = axios.get('/api/me');
            return promise.then((response) => {
                _self.canEdit = response.data.agent.slug === this.$route.params.slug;
            });
        },
        toast(message, variant){
            this.$bvToast.toast(message, {
                title: variant,
                variant: variant,
                solid: true
            })
        },
        checkifActivated(id) {
            return this.activatedArray.includes(id);
        },
        activateReadMore(id) {
            this.activatedArray.push(id);
        },
        writeTestimonial() {
            this.$refs['testimonialModal'].show();
        },
        testimonialAdded() {
            this.$refs['testimonialModal'].hide();
            this.toast('Your testimonial has been submitted!','success');
        },
    },
    mounted () {
        this.$eventHub.$on('testimonial::added', this.testimonialAdded);
    },
}
</script>

<style>
.quote {
    position: relative;
}

.card {
    height: 100%;
    width: 100%;
}

.quote:before {
    content: '\201c';
    position: absolute;
    font-family: serif;
    font-weight: 700;
    top: -40px;
    left: -10px;
    font-size: 130px;
    color: blue;
    opacity: 0.1;
}
</style>
